import { useRef, useEffect } from 'react';

const DEFAULT_DELAY_SECONDS = 500;

export default function useDebounceCallback(
  callback,
  delaySeconds = DEFAULT_DELAY_SECONDS,
) {
  const timeoutRef = useRef(null);

  const debounce = (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delaySeconds);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debounce;
}
